// Single source for the markdown → DOMQL tree handoff.
//
// @deprecated — use the MarkdownPreview component or applyMarkdownToElement
// from shared/components/MarkdownPreview.js directly. This shim delegates to
// that implementation and is kept for back-compat with consumers that call
// renderMarkdown() imperatively. Do not add new callers here.
//
// Legacy chat surfaces (MessageList, ThreadPanel, TicketDetailModal) continue
// to work unchanged because the shim forwards withMentions:true and
// demoteHeadings:false — matching the original behaviour. Workspace surfaces
// that need heading demotion should call applyMarkdownToElement directly with
// demoteHeadings:true, or mount a MarkdownPreview component.

import { applyMarkdownToElement } from '../../components/MarkdownPreview.js'

// Chat-specific components map. Kept as a named export so any remaining
// consumer that reads MARKDOWN_COMPONENTS by import continues to resolve.
export const MARKDOWN_COMPONENTS = {
  h1: 'H1', h2: 'H2', h3: 'H3', h4: 'H4', h5: 'H5', h6: 'H6',
  paragraph: 'P',
  pre: 'ChatCode',
  code: 'ChatInlineCode',
  codeBlock: 'ChatCode',
  blockquote: 'Blockquote',
  ul: 'ChatUL', ol: 'ChatOL', li: 'LI',
  hr: 'ChatHr',
  strong: 'Strong', em: 'Em', del: 'Del',
  link: 'Link', img: 'Img'
}

/**
 * @deprecated Use MarkdownPreview component or applyMarkdownToElement.
 * Back-compat shim — delegates to applyMarkdownToElement.
 * withMentions defaults to true (all legacy callers passed people/channels).
 * demoteHeadings:false preserves original chat behaviour (native h1-h6).
 * components: MARKDOWN_COMPONENTS preserves ChatCode/ChatUL/ChatHr etc.
 * TicketDetailModal now imports applyMarkdownToElement directly with
 * demoteHeadings:true, so it no longer routes through this shim.
 */
export const renderMarkdown = (el, body, emptyNode, people, channels) => {
  applyMarkdownToElement(el, body, emptyNode, {
    withMentions: true,
    demoteHeadings: false,
    components: MARKDOWN_COMPONENTS,
    people,
    channels
  })
}
